import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CadastroService } from 'src/app/services/cadastro.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

import { ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-alt-repres-legal',
    templateUrl: './alt-repres-legal.component.html',
    styleUrls: ['./alt-repres-legal.component.css'],
    imports: [ReactiveFormsModule]
})
export class AltRepresLegalComponent implements OnInit {

  @Output() exibirItem = new EventEmitter();

  loading: boolean = false;

  dados: any = null;
  tipos: any[] = [];

  form: FormGroup = null;
  msgErro: string = null;

  constructor(private cadastro: CadastroService, private toastr: ToastrService) { }

  ngOnInit() {
    this.carregarDados();
    this.listarTipos();
  }

  setForm(){

    let d = this.dados;

    this.form = new FormGroup({
        nome: new FormControl(d.NOME, [Validators.required]),
        cpf: new FormControl(d.DCR_CPF, [Validators.required]),
        codRepTipo: new FormControl(d.COD_REP_TIPO, [Validators.required]),
        celular: new FormControl(d.DCR_DDD_CELULAR + d.DCR_CELULAR, [Validators.required]),
        email: new FormControl(d.DCR_EMAIL, [Validators.required, Validators.email]),
        assinatura: new FormControl(null, [Validators.required]),
    });

  }

  carregarDados(){

    this.cadastro
        .represLegalCarregar()
        .subscribe(
          (res: any) => {

            if(res!=null){
              this.exibirItem.emit(true);
              this.dados = res;
              this.setForm();
            }

          },
          (error: HttpErrorResponse) => {

          }
        )
  }

  salvar(){

    this.loading = true;

    let celularCompleto: string = this.form.get("celular").value;

    let ddd = celularCompleto.substr(0, 2);
    let celular = celularCompleto.substr(2, celularCompleto.length);


    let dados: any = {
                      nome: this.form.get('nome').value,
                      cpf: this.form.get('cpf').value,
                      codRepTipo: this.form.get('codRepTipo').value,
                      celularDDI: 55,
                      celularDDD: ddd,
                      celular: celular,
                      email: this.form.get('email').value,
                      assinatura: this.form.get('assinatura').value,
                    };


    this.cadastro
        .represLegalSalvar(dados)
        .pipe(
          finalize(() => { this.loading=false })
        )
        .subscribe(
          (res: boolean) => {

            if(res){
              this.toastr.success("Alterações salvas com sucesso");
              this.form.get("assinatura").setValue("");
            }

          },
          (error: HttpErrorResponse) => {

            this.form.get("assinatura").setValue("");

            this.msgErro = error.error.ex;

            setTimeout(()=>{
              this.msgErro = null;
            }, 5000);

          }
        )

  }

  listarTipos(){

    this.cadastro
        .listarRepresLegalTipo()
        .subscribe(
          (res: any) => {

            this.tipos = res;
          },

        )
  }

}
